import { useNavigate, useLocation } from 'react-router-dom';
import { GraduationCap, Building2, ArrowLeftRight } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { hasFullAppAccess } from '@/lib/authRedirect';

export function ModeSwitcher() {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine current mode from URL
  const isInOposicionesC1Mode = location.pathname.includes('/oposiciones-c1');
  const isInOposicionesMode = !isInOposicionesC1Mode && location.pathname.includes('/oposiciones');
  const isInAnyOposicionesMode = isInOposicionesMode || isInOposicionesC1Mode;
  
  const handleSwitch = () => {
    if (isInAnyOposicionesMode) {
      navigate('/app/chat');
    } else {
      // Default to secretaria-intervencion oposiciones
      navigate('/app/oposiciones/chat');
    }
  };

  // Only show for betatesters
  if (!hasFullAppAccess(profile)) return null;

  return (
    <div className="px-4 py-3 border-t border-sidebar-border">
      <button
        onClick={handleSwitch}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg bg-gradient-to-r from-primary/10 to-accent/10 hover:from-primary/20 hover:to-accent/20 transition-all group"
      >
        <div className="flex items-center gap-3">
          {isInAnyOposicionesMode ? (
            <Building2 className="h-5 w-5 text-primary" />
          ) : (
            <GraduationCap className="h-5 w-5 text-primary" />
          )}
          <div className="text-left">
            <p className="text-xs text-muted-foreground">Modo actual</p>
            <p className="text-sm font-medium">
              {isInOposicionesC1Mode ? 'C1 - Admin. Estado' : isInOposicionesMode ? 'Oposiciones' : 'Funcionarios'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground group-hover:text-foreground transition-colors">
          <span className="hidden sm:inline">
            Cambiar a {isInAnyOposicionesMode ? 'Funcionarios' : 'Oposiciones'}
          </span>
          <ArrowLeftRight className="h-4 w-4" />
        </div>
      </button>
    </div>
  );
}
